"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var valueMap = function valueMap(allowableValues, propOfStyledComponent) {
  return allowableValues.reduce(function (acc, label) {
    acc[label] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (0, _styledComponents.css)(["", ";"], function (props) {
        return props[propOfStyledComponent] === label && _styledComponents.css.apply(void 0, args);
      });
    };
    return acc;
  }, {});
};
var _default = valueMap;
exports["default"] = _default;